export default "__VITE_ASSET__696eed0e__"